/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h, g as getElement } from './index-ef0fa435.js';

const buttonPushCss = "slot-fb[hidden].sc-lar-button-push,slot[hidden].sc-lar-button-push{display:initial !important}lar-button.sc-lar-button-push{width:var(--lar-push-button-size, 4rem);height:var(--lar-push-button-size, 4rem);line-height:var(--lar-push-button-size, 4rem);--lar-button-border-radius:50%;--lar-button-border-radius-small:50%;--lar-push-button-padding-top:0;--lar-push-button-padding-bottom:0;--lar-push-button-padding-left:0;--lar-push-button-padding-right:0;position:relative;margin:0 auto}lar-button.sc-lar-button-push lar-icon.sc-lar-button-push{--lar-icon-size-small:calc(var(--lar-push-button-size, 4rem) / 2.8);position:absolute;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}lar-button.lar-button-small.sc-lar-button-push{width:var(--lar-push-button-size-small, 2rem);height:var(--lar-push-button-size-small, 2rem);line-height:var(--lar-push-button-size-small, 2rem)}lar-button.lar-button-small.sc-lar-button-push lar-icon.sc-lar-button-push{--lar-icon-size-small:calc(var(--lar-push-button-size-small, 2rem) / 2.8)}";

const NodeButtonPush = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.color = 'primary';
    this.size = 'default';
    this.disabled = false;
  }
  render() {
    return (h("lar-button", { outline: true, color: this.color, disabled: this.disabled, size: this.size }, h("slot", null, h("lar-icon", { icon: "solid-circle" }))));
  }
  get el() { return getElement(this); }
};
NodeButtonPush.style = buttonPushCss;

export { NodeButtonPush as lar_button_push };

//# sourceMappingURL=lar-button-push.entry.js.map